import React from 'react';
import './Button.scss';

const Button = (props) => {
	const { disabled, btnId, className } = props;

	return (
		<div className={`primary-button ${className} ${disabled ? 'button-disabled' : ''}`} onClick={() => props.onClick(btnId)}>
			{props.children}
		</div>
	);
};

export default React.memo(Button);
